import React from 'react';
import {useDispatch} from 'react-redux';
import classNames from 'classnames';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import styles from './styles.module.scss';

/**
 * Deprecated button for uploading files. Use ButtonUploadFile instead.
 */
export const ButtonUploadExcel = ({uploadFunc, containerClassnames}) => {
  const dispatch = useDispatch();

  const uploadFileFunc = (file) => {
    dispatch(uploadFunc(file))
      .catch((error) => {
        console.error(`Error: + ${error}`);
      });
  };

  const onChange = (e) => {
    let file = e.target.files[0];
    uploadFileFunc(file);
  };

  return (
    <label className={classNames(styles.buttonUpload, 'btn btn-sm p-0 mb-0', containerClassnames)}>
      <img
        src={toAbsoluteUrl('/media/svg/Uploaded-file_white.svg')}
        alt="upload-file"
        height={24}
      />
      <input
        type="file"
        className="d-none"
        onChange={onChange}
        onClick={(e) => {
          e.target.value = null;
        }}
        multiple
      />
    </label>
  );
};

